var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"confirmationRef",attrs:{"id":_vm.id,"title":_vm.title,"ok-variant":"success"},on:{"ok":_vm.okPressed}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }